import { FsMarkerSymbolType, FsMarkerTextSymbolOptions } from '../../types/marker';
import { IBaseMarkerOptions } from './base-marker-options';
import { MapMarkerIcon } from './icon-marker-options';

import PinElementOptions = google.maps.marker.PinElementOptions;

export interface IMapMarkerStyleOptions {
  border?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
  strokeColor?: string;
  fillOpacity?: number;
  fillColor?: string;
  borderRadius?: string;
  overrideColor?: boolean;
  rotation?: number;
  scale?: number;
  shape?: IMapMarkerShape;
}

export enum IMapMarkerShape {
  Circle = 'circle',
  Pin = 'pin',
}

export interface IMapMarkerIconOptions {
  fontSet?: string;
  fontIcon?: string;
  color?: string;
  url?: string;
}

export interface IMapMarkerIconLabel {
  text: string;
  top?: number;
  left?: number;
  color?: string;
  fontSize?: string;
  transform?: string;
  field?: string;
}

export interface IMapMarkerLabel {
  text: string;
  color?: string;
  className?: string;
}

export interface IMapMarkerOptions extends IBaseMarkerOptions {
  attributes?: any;
  clickable?: boolean;
  collisionBehavior?: google.maps.CollisionBehavior;
  color?: string;
  content?: any;
  draggable?: boolean;
  icon?: MapMarkerIcon;
  iconLabel?: IMapMarkerIconLabel;
  isAxonLayer?: boolean;
  label?: string | IMapMarkerLabel;
  outline?: boolean;
  pinOptions?: PinElementOptions;
  rotation?: number;
  size?: string;
  style?: IMapMarkerStyleOptions;
  textSymbolOptions?: FsMarkerTextSymbolOptions;
  type?: FsMarkerSymbolType;
  zIndex?: number;
}
